<template>
    <button class="cz2__two_pack_selector__button">
        <img
            :src="packImage"
            alt=""
            aria-hidden="true"
            class="cz2__two_pack_selector__content__image-container"
        />

        <red-banner-button
            as="div"
            class="cz2__btn--two-pack-red-banner"
        >
            {{ bannerCopy }}
        </red-banner-button>

        <p class="cz2__two_pack_selector__button-copy">
            {{ contentCopy }}
        </p>

        <p
            class="cz2__two_pack_selector__button-copy cz2__two_pack_selector__button-price"
            v-html="priceCopy"
        />

        <btn
            as="span"
            class="cz2__btn--narrow cz2__btn--secondary"
        >
            <span>
                {{ ctaCopy }}
            </span>
        </btn>
    </button>
</template>

<script>
    import RedBannerButton from './RedBannerButton.vue';
    import Btn from './ui/Btn.vue';

    export default {
        name: 'TwoPackSelectorCard',

        components: {
            RedBannerButton,
            Btn,
        },

        props: {
            packImage: {
                type: String,
                default: '',
            },

            bannerCopy: {
                type: String,
                default: '',
            },

            contentCopy: {
                type: String,
                default: '',
            },

            priceCopy: {
                type: String,
                default: '',
            },

            ctaCopy: {
                type: String,
                default: '',
            },
        },
    };
</script>

<style lang="scss">
    @import '../style/variables';

    #cz2.cz2 {
        .cz2__two_pack_selector__button {
            position: relative;

            border-radius: 48px;
            padding: 16px;
            background: rgba(255, 255, 255, 0.4);

            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;

            width: 100%;
            height: 100%;

            .cz2__two_pack_selector__button-copy {
                padding: 0 8px;
                font-size: 15px;
                color: black;
            }

            .cz2__two_pack_selector__button-price {
                margin-top: 8px;
            }

            .cz2__btn--secondary {
                margin-top: 8px;

                width: 100%;
                height: 40px;

                font-size: 16px;

                &.cz2__btn--narrow:hover {
                    font-size: 19px;
                }
            }

            &:focus-visible {
                outline: none;
                border: 2px solid #1E5A99;
            }
        }

        .cz2__two_pack_selector__content__image-container {
            margin-bottom: 12px;
            height: 128px;
            width: auto;

            background-color: transparent;
            background-size: cover;
        }

        .cz2__btn--two-pack-red-banner {
            margin-bottom: 8px;
            filter: none;
            font-size: 22px;
            line-height: 33px;
            letter-spacing: 0;

            width: fit-content;
            padding: 0 16px 0 10px;
        }

        @include respond-above(lg) {
            .cz2__two_pack_selector__button-li {
                padding: 0;
            }

            .cz2__two_pack_selector__button {
                padding: 32px;
                width: 452px;

                .cz2__two_pack_selector__button-copy {
                    padding: 0 40px;
                }

                .cz2__btn--secondary {
                    margin-top: 16px;

                    font-size: 18px;
                    height: 48px;

                    &.cz2__btn--narrow:hover {
                        font-size: 21px;
                    }
                }
            }

            .cz2__two_pack_selector__content__image-container {
                margin-bottom: 24px;
                height: 260px;
            }

            .cz2__btn--two-pack-red-banner {
                font-size: 27px;
                line-height: 41px;
            }
        }

        @include respond-above(md) {
            .cz2__btn--two-pack-red-banner {
                margin-bottom: 10px;
            }

            .cz2__two_pack_selector__button {
                width: 452px;
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__two_pack_selector__button {
            width: 678px;
            height: auto;
            aspect-ratio: 452 / 502;

            .cz2__two_pack_selector__content__image-container {
            }

            .cz2__two_pack_selector__button-copy {
                font-size: 28px;
            }

            .cz2__btn--secondary {
                height: 80px;
                font-size: 40px;

                &.cz2__btn--narrow:hover {
                    font-size: 44px;
                }
            }
        }

        .cz2__btn--two-pack-red-banner {
            font-size: 80px;
            line-height: normal;
        }
    }
</style>
